import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { ProTipsServiceService } from '../service/pro-tips-service.service';
import { Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';


@Component({
  selector: 'app-nemt-pro-tips',
  templateUrl: './nemt-pro-tips.component.html',
  styleUrls: ['./nemt-pro-tips.component.css']
})
export class NemtProTipsComponent implements OnInit, OnDestroy {
  proTips = [];
  images = [];

  constructor(private proTipsService: ProTipsServiceService) { }

  ngOnInit() {
    this.getNemtProTips();
  }

  getNemtProTips() {
    this.proTipsService.getProTips()
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.proTips = data;
        }
      },
    );
  }

  // validUrl(): boolean {
  //   const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

  //   if(Validators.pattern(reg)){
  //     return true;
  //   }
  //   else return false;
  // }

  isValidHttpUrl(imgUrl) {
    

    return imgUrl ? imgUrl : 'assets/images/placeholders/no_image.png'
  }

  ngOnDestroy(): void {
  }
}
